<ng-select
  id="clientId"
  (change)="onClientSelectionChange($event)"
  (clear)="clearSearchClients()"
  (input)="onInput($event)"
  [ngModel]="selectedClient"
  [clearable]="true"
  [searchFn]="customSearchFn"
  [items]="clientOptions"
  [multiple]="false"
  [searchable]="true"
  (close)="Onclose()"
  [closeOnSelect]="true"
  placeholder="Select Client">
  <ng-template ng-label-tmp let-item="item">
    <div>
      <ng-container *ngIf="item.name">
        <span class="rectangle-tag bg-success mr-2">{{ item.name }}</span>
      </ng-container>
      <ng-container *ngIf="item.id">
        <span class="rectangle-tag bg-info mr-2">{{ item.id }}</span>
      </ng-container>
    </div>
  </ng-template>

  <ng-template ng-option-tmp let-item="item" let-index="index">
    <div>
      <ng-container *ngIf="item?.name">
        <span class="rectangle-tag bg-success mr-2">{{ item.name }}</span>
      </ng-container>
      <ng-container *ngIf="item?.id">
        <span class="rectangle-tag bg-info">{{ item.id }}</span>
      </ng-container>
    </div>
  </ng-template>
</ng-select>
